import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PhotosComponent } from './photos/photos.component';
import { QuestionsComponent } from './questions/questions.component';
import { ResponseComponent } from './response/response.component';

const routes: Routes = [
  {
    path: 'questions',
    component: QuestionsComponent
  },
  {
    path: 'photos',
    component: PhotosComponent
  },
  {
    path: 'response',
    component: ResponseComponent
  },
  {
    path: 'response',
    component: ResponseComponent
  }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
